export default __webpack_public_path__ + "assets/images/aistudio/empty_state/3e645b36315ab7b556b3b93ca6246843.png";